import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';

@Injectable()
export class NotAllowPartnerRestrictGuardService implements CanActivate {

    constructor(
        private authTokenService: AuthTokenService,
        private router: Router,
    ) { }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        // tslint:disable-next-line:no-bitwise
        if (this.authTokenService.role & RoleTypes.PartnerRestrict) {
            this.router.navigate(['page-forbidden']);

            return false;
        }

        return true;
    }

}
